<div class="gd-change-password-dialog gd-global-material-dialog-padding" [dir]="dir$ | async">
  <form
    class="tw-flex tw-flex-col tw-justify-around tw-items-stretch tw-gap-2"
    [formGroup]="changePasswordForm"
    (ngSubmit)="save()"
    novalidate>
    <h2 class="mat-h2" i18n>Change Password</h2>

    <section>
      <mat-form-field class="gd-change-password-dialog__input" subscriptSizing="dynamic"
        appearance="outline"
        [ngClass]="!passwordControl.touched || passwordControl.valid ? '!tw-mb-6' : '!tw-mb-2'">
        <mat-label i18n>New Password</mat-label>
        <input matInput
          type="password"
          autocomplete="new-password"
          formControlName="password">
          <mat-icon matSuffix
            class="question-icon"
            i18n-matTooltip
            matTooltip="Password must be at least 10 characters long and it must contain at least one uppercase letter, one lowercase letter, one numeric digit and one special character."
            matTooltipPosition="left"
            fontSet="fal"
          fontIcon="fa-question-circle"></mat-icon>
          @if (passwordControl.hasError('required')) {
            <mat-error i18n>Password is required.</mat-error>
          }
          @if (passwordControl.hasError('minlength')) {
            <mat-error i18n>Password must be at least 12 characters long.</mat-error>
          }
          @if (passwordControl.hasError('pattern')) {
            <mat-error i18n>Password must contain at least one uppercase letter, one lowercase letter, one numeric digit and one special character.</mat-error>
          }
        </mat-form-field>
      </section>

      <section>
        <mat-form-field class="gd-change-password-dialog__input --confirm" appearance="outline">
          <mat-label i18n>Confirm Password</mat-label>
          <input matInput
            type="password"
            autocomplete="new-password"
            formControlName="confirmPassword">
            <mat-error i18n>Password doesn't match.</mat-error>
          </mat-form-field>
        </section>

        <section class="gd-change-password-dialog__section-buttons">
          <button mat-raised-button
            color="primary"
            type="submit"
            i18n
            class="gd-change-password-dialog-buttons--save"
          [disabled]="!passwordControl.valid || !confirmPasswordControl.valid">Save</button>
          <button mat-raised-button
            color="danger"
            i18n
          mat-dialog-close>Cancel</button>
        </section>
      </form>
    </div>
